import React from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import logo from '../../svg/LogoBlue.svg'

const RegistrationBlock = ({ bgColor = '#FFFFFF', t }) => {
    return (
        <div className="__registration-block" style={{ backgroundColor: bgColor }}>
            <div className="logo">
                <img src={logo} alt="" />
            </div>
            <ul className="balls">
                <li className="ball ball--1"></li>
                <li className="ball ball--2"></li>
                <li className="ball ball--3"></li>
                <li className="ball ball--4"></li>
                <li className="ball ball--5"></li>
            </ul>
            <h3 className="dark">{t('_components._registration.title')}</h3>
            <div className="buttons">
                <Link className="button-style" data-size="lg" to="/auth?action=registration">
                    {t('Create account')}
                </Link>
            </div>
            <p>{t('_components._registration.why_not_try')}</p>
        </div>
    )
}

export default withTranslation('translations')(RegistrationBlock)
